import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { AuthService } from './../auth/auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ForcelogoutComponent } from '../forcelogout/forcelogout.component';
import { ForgotPasswordpopupComponent } from '../forgot-passwordpopup/forgot-passwordpopup.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MD5UtilService } from '../services/MD5Util.service';
import { CountdownComponent } from 'ngx-countdown';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  private formSubmitAttempt: boolean;
  private formSubmitAttempt2: boolean;

  returnUrl: string;
  loginUserType: string="retailer"
  Ip: any;
  isloading: boolean;
  // hide = true;
  otpform: FormGroup;
  otp:boolean;
  hide1: any;
  hide = false;
  registerMobile: any;
  refNumber:any
  isResendEnable: boolean = false;
  @ViewChild('countdown') counter: CountdownComponent;
  ymLogoPng: string;
  otpType: any;
  otpMessage:any;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    public dialog: MatDialog,
    private md5Util:MD5UtilService
  ) {
    this.ymLogoPng=environment.ym_logo_png;
    localStorage.setItem('userType', 'agent-login');
    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    localStorage.clear()
    this.form = this.fb.group({
      userName: ['', Validators.required],
      // password: ['', Validators.required]
    });
    this.otpform = this.fb.group({
      enterOtp:["",Validators.required]
     


    }) ;
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/login';
    this.loginUserType = 'agent-login';
    this.authService.getIp().subscribe((data) => {
      this.Ip = data['ip'];
    });
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  isFieldInvalid(field: string) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }
  isOtpInvalid(field: string) {
    return (
      (!this.otpform.get(field).valid && this.otpform.get(field).touched) ||
      (this.otpform.get(field).untouched && this.formSubmitAttempt2)
    );
  }
  handleTabChange(usertype) {
    this.loginUserType = usertype;
    localStorage.setItem('userType', this.loginUserType);
    console.log('this.loginUserType::', this.loginUserType);
  }
  validateOtpsend(otpTrue){
    if(otpTrue){
      if(this.otpform.invalid){
        return
      }else{
        this.validateOtpApi();

      }

    }
  }
  validateOtpApi(){
    this.ngxService.start();
    this.authService.validateRetOtp2(this.otpform.value.enterOtp,this.refNumber)
    .pipe(first())
    .subscribe(
      (data:any) => {
        this.ngxService.stop();
      if(data.status_code == 1){
        this.toastr.success(data.message);
        
        if(data.object.mobile){
          localStorage.setItem('retailor_phoneNumber',data.object.mobile)
        }
        localStorage.setItem('uniqueName',data.object.uniqueName);
        localStorage.setItem('ym_id',this.md5Util.getAESEncrption(data.object.uniqueName));
        localStorage.setItem('retailorYmSecret',this.md5Util.getAESEncrption(data.object.retailorYmSecret));
        localStorage.setItem('retailorYmid',this.md5Util.getAESEncrption(data.object.retailorYmid));

        localStorage.setItem('userId',data.object._id);
        localStorage.setItem('uacid',data.object.uacid);
        localStorage.setItem('wallet-token',data.object.accessToken);
        localStorage.setItem('userAgent',data.object.userAgent);
        localStorage.setItem('md5key',data.object.md5key);
        localStorage.setItem('tapekycstatus',data.object.tapekycstatus);
        localStorage.setItem('PAN',data.object.pan);
        localStorage.setItem('yesBankEkycStatus',data.object.yesBankEkycStatus);
        localStorage.setItem("node_token",data.object.token)
        localStorage.setItem("mdeviceStaus",data.object.mdeviceStaus)
        localStorage.setItem('retailorParentDistributorUniqueName',data.object.retailorParentDistributorUniqueName)
        localStorage.setItem('longitute',data.object.longitute)
        localStorage.setItem('latitute',data.object.latitute)
      
        localStorage.setItem("emp_mobile",data.object.emp_mobile)
        localStorage.setItem('retailorName',data.object.retailorName)
        localStorage.setItem('emailId',data.object.emailId)
        localStorage.setItem('login','true')



        // console.log(data.user.mobile)
        this.router.navigate(['/dashboard']);
      } else if (data.object.status_code == 0) {
        localStorage.setItem('userType', this.loginUserType);
        this.ngxService.stop();
        this.toastr.error(data.data.message, '');
        this.focelogout();
      } else {
        this.ngxService.stop();
        this.toastr.error(data.data.message, '');
      }
       
      },
      errData => {
        this.ngxService.stop();
        this.toastr.error(errData.error.message, '');
        console.log('....dssfsf..>>', errData.error);
      
      }
    );
    // this.authService.validateRetOtp(this.otpform.value,this.form.value,this.Ip,this.otpType)
    //   .pipe(first())
    //   .subscribe(
    //     (data:any) => {
    //       this.ngxService.stop();
    //     if(data.status == 200){
    //       this.toastr.success(data.message);
          
    //       if(data.user.mobile){
    //         localStorage.setItem('retailor_phoneNumber',data.user.mobile)
    //       }
    //       localStorage.setItem('uniqueName',data.kyc.uniqueName);
    //       localStorage.setItem('ym_id',this.md5Util.getAESEncrption(data.kyc.uniqueName));
    //       localStorage.setItem('retailorYmSecret',this.md5Util.getAESEncrption(data.walletResut.retailorYmSecret));
    //       localStorage.setItem('retailorYmid',this.md5Util.getAESEncrption(data.walletResut.retailorYmid));

    //       localStorage.setItem('userId',data.user._id);
    //       localStorage.setItem('uacid',data.user.uacid);
    //       localStorage.setItem('wallet-token',data.walletResut.accessToken);
    //       localStorage.setItem('userAgent',data.walletResut.userAgent);
    //       localStorage.setItem('md5key',data.walletResut.md5key);
    //       localStorage.setItem('tapekycstatus',data.walletResut.tapekycstatus);
    //       localStorage.setItem('PAN',data.kyc.pan_no);
    //       localStorage.setItem('yesBankEkycStatus',data.walletResut.yesBankEkycStatus);
    //       localStorage.setItem("node_token",data.token)
    //       localStorage.setItem("mdeviceStaus",data.walletResut.mdeviceStaus)
    //       localStorage.setItem('retailorParentDistributorUniqueName',data.walletResut.retailorParentDistributorUniqueName)
    //       localStorage.setItem('longitute',data.walletResut.longitute)
    //       localStorage.setItem('latitute',data.walletResut.latitute)
        
    //       localStorage.setItem("emp_mobile",data.walletResut.emp_mobile)

    //       // console.log(data.user.mobile)
    //       this.router.navigate(['/dashboard']);
    //     } else if (data.data.status == 400 || data.data.status == 401) {
    //       localStorage.setItem('userType', this.loginUserType);
    //       this.ngxService.stop();
    //       this.toastr.error(data.data.message, '');
    //       this.focelogout();
    //     } else {
    //       this.ngxService.stop();
    //       this.toastr.error(data.data.message, '');
    //     }
         
    //     },
    //     errData => {
    //       this.ngxService.stop();
    //       this.toastr.error(errData.error.message, '');
    //       console.log('....dssfsf..>>', errData.error);
        
    //     }
    //   );
  }
  resendOTP() {
    this.formSubmitAttempt = true;
    this.ngxService.start();
    this.authService.loginWithOtp2(this.form.value,this.otpType)
      .pipe(first())
      .subscribe(
        (data: any) => {
           this.ngxService.stop();

           if (data.status == 200) {
            this.isResendEnable = false;
    
          } else {
            this.toastr.error(data.error.message);
    
          }
      },errData => {
        console.log(errData);
        this.toastr.error(errData.error.message);
        this.ngxService.stop();

       
      }
    );
  }
  selectOtpType(otpType){
    this.otpType=otpType;
    if(otpType=='EMAIL'){
      this.otpMessage="OTP has sent to your registered email.";
    }else{
      this.otpMessage="OTP has sent to your registered mobile.";

    }
  }
  onSubmit() { 
    // this.retailerLogin();
    this.formSubmitAttempt = true;
    this.ngxService.start();
    this.authService.loginWithOtp2(this.form.value,this.otpType)
    .pipe(first())
    .subscribe(
      (data: any) => {
         this.ngxService.stop();

        if(data.status_code == 1 ){
          this.otp = true;
          // this.registerMobile = data.data.mobile
          this.refNumber = data.object.refNumber
          //  this.retailerLogin();

        }
        // else if(data.status_code == 1 ){
        //  this.retailerLogin();
        // }
        else if(data.status_code == 0){
          this.toastr.error(data.error.message);
        }
      },
      errData => {
        console.log(errData);
        this.toastr.error(errData.error.message);
        this.ngxService.stop();

       
      }
    );
    // this.authService.loginWithOtp(this.form.value,this.Ip,this.otpType)
    //   .pipe(first())
    //   .subscribe(
    //     (data: any) => {
    //        this.ngxService.stop();

    //       if(data.status == 200 && data.data.otpSend == true){
    //         this.otp = true;
    //         this.registerMobile = data.data.mobile
    //         //  this.retailerLogin();

    //       }
    //       else if(data.status == 200 && data.data.otpSend == false){
    //        this.retailerLogin();
    //       }
    //     },
    //     errData => {
    //       console.log(errData);
    //       this.toastr.error(errData.error.message);
    //       this.ngxService.stop();

         
    //     }
    //   );
  }
  handleEvent(event) {
    console.log(event.action);
    if (event.action == 'finished') {
      this.isResendEnable = true;
      console.log(this.isResendEnable);
    }
  }
  retailerLogin() {
    
    this.formSubmitAttempt = true;
    this.validateOtpApi();
   
  }
  
  focelogout() {
    const dialogRef = this.dialog.open(ForcelogoutComponent, {
      data: { mobileNo: '', email: this.form.value.userName }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  forgetPass() {
    // const params = {
    //   email: this.form.value.userName
    // };
    // this.authService.forgetPassword(params).subscribe((res) => {
    //   console.log('res', res);
    // })
    const dialogRef = this.dialog.open(ForgotPasswordpopupComponent, {
      width: '40%',
      data: { mobileNo: '', email: this.form.value.userName }
     
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}
